import React, { useState, useEffect } from 'react';
import Plot from 'react-plotly.js';
import financialService from '../../services/financialService';
import './FinancialDashboard.css';

const TopUtilityCharts = ({ marketplace, cacheKey, horizonteTemporal = 'Mensual', tipoVolumen = 'Predicciones' }) => {
  const [loading, setLoading] = useState(true);
  const [dimension, setDimension] = useState('proveedor');
  const [chartsData, setChartsData] = useState(null);
  const [error, setError] = useState(null);
  
  useEffect(() => {
    loadCharts();
  }, [marketplace, cacheKey, dimension, horizonteTemporal, tipoVolumen]);
  
  const loadCharts = async () => {
    setLoading(true);
    setError(null);
    
    try {
      const result = await financialService.getTopUtilityCharts(
        marketplace, 
        cacheKey, 
        dimension,
        horizonteTemporal,
        tipoVolumen
      );
      
      if (result.success) {
        setChartsData(result);
      }
    } catch (err) {
      console.error('Error cargando top utility charts:', err);
      setError(err.response?.data?.detail || err.message);
    } finally {
      setLoading(false);
    }
  };
  
  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Cargando gráficos de utilidad...</p>
      </div>
    );
  }
  
  if (error) {
    return (
      <div className="error-container">
        <p>❌ {error}</p>
        <button onClick={loadCharts} className="btn btn-primary">
          🔄 Reintentar
        </button>
      </div>
    );
  }
  
  if (!chartsData) {
    return <div className="no-data">No hay datos disponibles</div>;
  }
  
  return (
    <div className="top-utility-charts">
      <div className="charts-header">
        <h3>🏆 Top Utilidad y Pérdidas</h3>
        <div className="dimension-selector">
          <label>Analizar por:</label>
          <select 
            value={dimension} 
            onChange={(e) => setDimension(e.target.value)}
            className="dimension-select"
          >
            <option value="proveedor">Proveedor</option>
            <option value="sku">SKU</option>
            <option value="identificador">Identificador</option>
          </select>
        </div>
      </div>
      
      <div className="chart-section">
        <h4>Top 10 por Utilidad Total</h4>
        <div className="chart-container">
          <Plot
            data={chartsData.top_10_utility.data}
            layout={{
              ...chartsData.top_10_utility.layout,
              autosize: true
            }}
            config={{
              responsive: true, 
              displayModeBar: true,
              modeBarButtonsToRemove: ['pan2d', 'lasso2d'],
              displaylogo: false
            }}
            style={{ width: '100%', height: '400px' }}
            useResizeHandler={true}
          />
        </div>
      </div>
      
      <div className="chart-section">
        <h4>Top 10 con Mayor Pérdida</h4>
        <div className="chart-container">
          <Plot
            data={chartsData.top_10_losses.data}
            layout={{
              ...chartsData.top_10_losses.layout,
              autosize: true
            }}
            config={{
              responsive: true,
              displayModeBar: true,
              modeBarButtonsToRemove: ['pan2d', 'lasso2d'],
              displaylogo: false
            }}
            style={{ width: '100%', height: '400px' }}
            useResizeHandler={true}
          />
        </div>
      </div>
      
      {chartsData.providers_with_losses && (
        <div className="chart-section">
          <h4>Top 10 Proveedores con Más Productos en Pérdida</h4>
          <div className="chart-container">
            <Plot
              data={chartsData.providers_with_losses.data}
              layout={{
                ...chartsData.providers_with_losses.layout,
                autosize: true
              }}
              config={{
                responsive: true,
                displayModeBar: true,
                modeBarButtonsToRemove: ['pan2d', 'lasso2d'],
                displaylogo: false
              }}
              style={{ width: '100%', height: '400px' }}
              useResizeHandler={true}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default TopUtilityCharts;

